import type { Favorite } from '@k-ucap/shared';
import type { FavoriteRepository } from './RepositoryInterfaces.js';

export class InMemoryFavoriteRepository implements FavoriteRepository {
  private favorites: Map<string, Favorite> = new Map();

  async findAll(): Promise<Favorite[]> {
    return Array.from(this.favorites.values()).sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  async findById(id: string): Promise<Favorite | undefined> {
    return this.favorites.get(id);
  }

  async findByUserId(uid: string): Promise<Favorite[]> {
    return Array.from(this.favorites.values())
      .filter((f) => f.uid === uid)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  }

  async findByUserAndAsset(uid: string, assetType: string, assetId: string): Promise<Favorite | undefined> {
    return Array.from(this.favorites.values()).find(
      (f) => f.uid === uid && f.assetType === assetType && f.assetId === assetId
    );
  }

  async save(favorite: Favorite): Promise<Favorite> {
    this.favorites.set(favorite.id, favorite);
    return favorite;
  }

  async delete(id: string): Promise<void> {
    this.favorites.delete(id);
  }

  seed(favorites: Favorite[]): void {
    favorites.forEach((f) => this.favorites.set(f.id, f));
  }
}

export const createInMemoryFavoriteRepository = (): InMemoryFavoriteRepository => new InMemoryFavoriteRepository();
